import { createFileRoute, Outlet } from "@tanstack/react-router";
import { TopNav } from "@/routes/innovation-days-demo/components/TopNav";
import { Header } from "@/routes/innovation-days-demo/components/Header";
import { toast } from "@/utils/toast";
import data from "@/routes/innovation-days-demo/data/little_prince_metadata.json" with { type: "json" };
import type { ManuscriptMetadata } from "@/routes/innovation-days-demo/types";

function InnovationDaysDemoLayout() {
  const manuscript = data as ManuscriptMetadata;

  return (
    <div className="flex flex-col h-screen bg-secondary-50">
      <TopNav />
      <div className="flex-1 pt-[4rem]">
        <div className="flex flex-col bg-secondary-50">
          <Header
            title={manuscript.title}
            author={manuscript.author}
            onUploadUpdatedManuscript={() =>
              toast.info("This feature is not yet implemented.")
            }
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/innovation-days-demo/_layout")({
  component: InnovationDaysDemoLayout,
});
